/**
 * Report catalogue. Each entry is implemented once on the server as a dataset
 * builder; Excel, CSV and PDF are three renderers over the same rows, so a new
 * report needs one builder and nothing else.
 */
export const REPORTS = [
  {
    key: 'bright_stock',
    name: 'Bright stock report',
    description: 'Every vehicle currently held by Bright on Wheels, with ageing.',
  },
  {
    key: 'dealer_stock',
    // The key stays; the words follow the owner (1 Oct 2026: "dealers cant
    // have stock"). A vehicle sent to a dealer is Autozone's sale.
    name: 'Sold to dealers report',
    description: 'Vehicles Bright Autozone has sold to each dealer, grouped by dealer.',
  },
  {
    key: 'sub_dealer_stock',
    name: 'Sub dealer stock report',
    description: 'Stock held by each sub dealer, with its parent dealer.',
  },
  {
    key: 'outlet_stock',
    name: 'Company outlet stock report',
    description: 'Stock held by each company owned outlet.',
  },
  {
    key: 'complete_inventory',
    name: 'Complete inventory report',
    description: 'Every vehicle on the books with current custody and status.',
  },
  {
    key: 'ageing',
    name: 'Inventory ageing report',
    description: 'Vehicles bucketed 0–15, 16–30, 31–60, 61–90 and 90+ days.',
  },
  {
    key: 'movement',
    name: 'Vehicle movement report',
    description: 'Every custody change in a period, from and to.',
  },
  {
    key: 'billing',
    name: 'Billing report',
    description: 'Invoices, billing dates and values by month.',
  },
  {
    key: 'asm_performance',
    name: 'ASM performance report',
    description: 'Dispatches, sales and holding time by area sales manager.',
  },
] as const;

export type ReportKey = (typeof REPORTS)[number]['key'];
export const REPORT_KEYS = REPORTS.map((r) => r.key) as ReportKey[];
export const REPORT_FORMATS = ['XLSX', 'CSV', 'PDF'] as const;
export type ReportFormat = (typeof REPORT_FORMATS)[number];
